import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { EnvironmentStore } from './environment.store';

@Component({
  selector: 'rb-environment',
  imports: [CommonModule],
  templateUrl: './environment.component.html',
  styleUrls: ['./environment.component.scss'],
})
export class EnvironmentComponent implements OnInit {
  readonly store = inject(EnvironmentStore);

  ngOnInit(): void {
    if (!this.store.info()) {
      this.store.getEnvironment();
    }
  }
}
